import React, { useContext, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import CustomerAuthContext from '../../context/customerAuth/customerAuthContext';

const CustomerPrivateRoute = ({ children }) => {
  const { customer, token, loadCustomer } = useContext(CustomerAuthContext);
  const hasToken = token || localStorage.getItem('customer_token');

  useEffect(() => {
    if (hasToken && !customer) {
      loadCustomer().catch(() => {});
    }
  }, [hasToken, customer, loadCustomer]);

  if (!hasToken) {
    return <Navigate to="/customer/login" replace />;
  }

  return children;
};

export default CustomerPrivateRoute;
